import React, { useState } from "react";
import {
  TextField,
  InputAdornment,
  Button,
  Grid,
  Autocomplete,
  Paper,
  Typography,
  Box,
} from "@mui/material";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import SearchIcon from "@mui/icons-material/Search";
import EngineeringIcon from "@mui/icons-material/Engineering";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import HomeIcon from "@mui/icons-material/Home";
import PopupGeneric from "../../Components/PopupGeneric/pop-up-generic";
import WorkIcon from '@mui/icons-material/Work';

const WorkOrderForm = ({ formType, task, workOrder, onSubmit, onClose }) => {
  // const [selectedTechnician, setSelectedTechnician] = useState(task?.assignee || "");
  // // const [date, setDate] = useState(task?.workOrderTaskDate ? dayjs(task.workOrderTaskDate) : null);
  // const [date, setDate] = useState(
  //   task?.workOrder?.initialServiceDate ? dayjs(task.workOrder.initialServiceDate) : null
  // );
  // // const [additionalComments, setAdditionalComments] = useState(task?.workOrderTaskComment || "");
  // const [additionalComments, setAdditionalComments] = useState(
  //   task?.workOrder?.workOrderComment || ""
  // );
  const [selectedTechnician, setSelectedTechnician] = useState(formType === "task" ? task?.assignee : workOrder?.assignee);
  const [date, setDate] = useState(formType === "task" ? (task?.workOrderTaskDate ? dayjs(task.workOrderTaskDate) : null) : (workOrder?.workOrderDate ? dayjs(workOrder.workOrderDate) : null));
  const [additionalComments, setAdditionalComments] = useState(formType === "task" ? (task?.workOrderTaskComment || "") : (workOrder?.workOrderComment || ""));
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");


  const handleSubmit = (e) => {

    
    e.preventDefault();
    
    if (!selectedTechnician) {
        setPopupMessage("Please assign a technician before saving.");
        setPopupVisible(true);
        return;
    }
    if (formType === "task") {
      const updatedTask = {
        ...task,
        customerName: task?.customerName, 
        address: task?.address, 
        selectedTechnician,
        date,
        additionalComments,
      };
      onSubmit(updatedTask);
    }
    if (formType === "workorder") {
      const updatedWorkOrder = {
        ...workOrder,
        customerName: workOrder?.customerName, 
        address: workOrder?.address, 
        selectedTechnician,
        date,
        additionalComments,
        typeWork: workOrder?.workOrderType
      };
      onSubmit(updatedWorkOrder);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px" }}>
        <Paper elevation={3} sx={{ padding: "20px", width: "60%", textAlign: "center" }}>
          <Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: "20px" }}>
            {formType === "task" ? "Edit Task" : "Edit Work Order"}
          </Typography>

          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {/* Customer Name - Non-editable */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Customer Name"
                  value={formType === "task" ? task?.customerName : workOrder?.customerName || ""}
                  InputProps={{
                    readOnly: true,
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  disabled
                />
              </Grid>

              {/* Address - Non-editable */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Address"
                  value={formType === "task" ? task?.address : workOrder?.address || ""}
                  InputProps={{
                    readOnly: true,
                    startAdornment: (
                      <InputAdornment position="start">
                        <HomeIcon />
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  disabled
                />
              </Grid>

              {/* Assign Technician */}
              <Grid item xs={12}>
                <Autocomplete
                  options={formType === "task" ? task?.employeeList : workOrder?.employeeList || []}
                  getOptionLabel={(option) => `${option.firstName} ${option.lastName}` || ""}
                  value={selectedTechnician}
                  onChange={(event, newValue) => setSelectedTechnician(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Assign Technician"
                      variant="outlined"
                      required
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <InputAdornment position="start">
                            <EngineeringIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>

              {/* Further Comments */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Further Comments"
                  value={additionalComments}
                  onChange={(event) => setAdditionalComments(event.target.value)}
                  multiline
                  rows={3}
                  variant="outlined"
                />
              </Grid>

              {formType === "workorder" && (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Work Order Type"
                  value={workOrder?.workOrderType || ""}
                  InputProps={{
                    readOnly: true,
                    startAdornment: (
                      <InputAdornment position="start">
                        <WorkIcon/>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  disabled
                />
              </Grid>
            )}


              {/* Date Picker */}
              <Grid item xs={12}>
                <DatePicker
                  label="Select Date"
                  value={date}
                  onChange={(newValue) => setDate(newValue)}
                  required
                  disablePast
                  slotProps={{
                    textField: {
                      InputProps: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <CalendarTodayIcon />
                          </InputAdornment>
                        ),
                      },
                    },
                  }}
                />
              </Grid>

            
            </Grid>

            {/* Submit and Cancel Buttons */}
            <Button
              variant="contained"
              type="button"
              onClick={handleSubmit}
              sx={{
                marginTop: "20px",
                width: "100%",
                padding: "12px",
                fontWeight: "bold",
                backgroundColor: "#002244",
                color: "white",
              }}
            >
              Save Changes
            </Button>
            <Button
              variant="outlined"
              onClick={onClose}
              sx={{
                marginTop: "10px",
                width: "100%",
                fontWeight: "bold",
              }}
            >
              Cancel
            </Button>
          </form>
        </Paper>
        {/* Popup Alert */}
        <PopupGeneric
          isVisible={isPopupVisible}
          onClose={() => setPopupVisible(false)}
          title="Alert"
          content={<p>{popupMessage}</p>}
          actions={
            <button
              onClick={() => setPopupVisible(false)}
              style={{
                marginTop: '10px',
                padding: '5px 10px',
                borderRadius: '5px',
                backgroundColor: '#003366',
                color: '#fff',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              OK
            </button>
          }
        />
      </Box>
    </LocalizationProvider>
  );
};

export default WorkOrderForm;


